module.exports = __webpack_public_path__ + "img/outlander2022Big.dcc8b7f6.jpg";